import { useEffect, useRef } from 'react';
import { logAnalyticsEvent, logGoogleAdsConversion, GOOGLE_ADS_CONVERSIONS } from '../utils/analytics';

/**
 * Record a completed Stripe checkout once, on the page Stripe returns to.
 *
 * Requires BOTH the ?success=true param (present on Stripe's redirect, read
 * once at mount) AND an active/trialing subscription, so a visitor typing the
 * URL without a subscription records nothing. The param is then removed so a
 * reload does not record it again. The Google Ads conversion counts once per
 * ad click (ONE_PER_CLICK), and only for a visitor who arrived from an ad.
 */
export default function useCheckoutSuccessConversion(searchParams, setSearchParams, subscriptionStatus) {
  const pendingSuccessRef = useRef(searchParams.get('success') === 'true');
  useEffect(() => {
    if (!pendingSuccessRef.current) return;
    if (!subscriptionStatus || subscriptionStatus.tier !== 'pro') return;
    logAnalyticsEvent('subscription_checkout_session_success');
    logGoogleAdsConversion(GOOGLE_ADS_CONVERSIONS.TRIAL_STARTED);
    pendingSuccessRef.current = false;
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('success');
    setSearchParams(newParams, { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionStatus]);
}
